import { FormikValues } from 'formik';

import { Field, FieldError, FieldValidationFunction, FieldValidationTypes } from '../types';

type FieldValidateHelperParams<
  TValue extends any = any,
  TValues extends FormikValues = FormikValues,
> = {
  field: Field<TValue, TValues>;
  value: TValue;
  values: TValues;
  fieldValidation: FieldValidationFunction<TValue, TValues>;
};

const fieldValidate = <TValue extends any = any, TValues extends FormikValues = FormikValues>({
  field,
  value,
  values,
  fieldValidation,
}: FieldValidateHelperParams<TValue, TValues>) => {
  if (field.validation && field.validation.length > 0) {
    let error: FieldError;
    field.validation.forEach((validation) => {
      if (error) {
        return;
      }

      const fieldValidationEntry = fieldValidation[validation.type];

      if (fieldValidationEntry && validation.type !== FieldValidationTypes.Custom) {
        // @ts-expect-error
        error = fieldValidationEntry({ field, value, validation });
      }

      if (validation.type === FieldValidationTypes.Custom) {
        // @ts-expect-error
        error = validation.validate?.(field, value, values);
      }
    });

    return error;
  }

  return undefined;
};

export default fieldValidate;
